import requestAction from '../../utils/requestAction'

export const uploadComplaintMessageFile = (formData: FormData, complaintId: number, handleResponse: (fileId: string) => void) =>
  requestAction('COMPLAINT_MESSAGE_UPLOADFILE')(
    `complaints/message/upload/${complaintId}`,
    'POST',
    formData,
    undefined,
    'file',
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.fileId) })

